Fastweb.Admin.Articles = (function($) {

  init = function() {
    articleEditorSetup();
    $("select[data-behavior=article-channel]").change(function() {
      var url = window.location.origin;
      $.get({
        url: url + '/admin/articles/article_categories',
        dataType: 'json',
        data: {channel_id: $(this).val()}
      }).done(function(data) {
        var html = '';
        data.forEach(function(element) {
          html = html + '<option value="' + element.id + '">' + element.name + '</option>';
        });
        $('#article_categories').html(html);
      });
    });

    const articleBody = $('#article-editor')
    $('#admin-article-form').on('submit', function() {
      if(articleBody.attr('wrap') == 'on') {
        articleBody.attr('wrap', 'off') 
      }
    })
  }

  function validateArticleBodyForPlacements() {
    const save = $('#save-button')
    let articleBody = $('#article-editor')
    let errorsList = $(document.createElement('ul')).attr('id', 'in-feed-errors-list')[0];
    let li = document.createElement('li');
    // check for more than 3 in_feed_placements
    let matches = articleBody.val().toLowerCase().match(/(in_feed_placement)/g)
    
    if (matches != null && matches.length >= 4) {
      li.appendChild(document.createTextNode(`You can only have a max of 3 [IN_FEED_PLACEMENT] tags per article. Please remove ${matches - 3} and re-validate to save. `));
      errorsList.appendChild(li);
      save.prop('disabled', true)
      articleBody.css('background-color', '#f9ecea')
    } else {
      save.prop('disabled', false)
      articleBody.css('background-color', 'white')
    }
    $('#in-feed-placements').html(errorsList);    
    $('#in-feed-placements').show()    
  }

  function articleEditorSetup() {
    let articleEditor = document.getElementById('article-editor');
    let lineCounter = document.getElementById('line-counter');

    articleEditor.addEventListener('scroll', () => {
      lineCounter.scrollTop = articleEditor.scrollTop;
      lineCounter.scrollLeft = articleEditor.scrollLeft;
    });

    articleEditor.addEventListener('keydown', (e) => {
      let { keyCode } = e;
      let { value, selectionStart, selectionEnd } = articleEditor;
      if (keyCode === 9) { // 9 --> tab
        e.preventDefault();
        articleEditor.value = value.slice(0, selectionStart) + '\t' + value.slice(selectionEnd);
        articleEditor.setSelectionRange(selectionStart+2, selectionStart+2)
      }
    });

    line_counter(articleEditor, lineCounter);
    articleEditor.addEventListener('input', function() {
      var lineCountCache = 0;
      var lineCount = articleEditor.value.split('\n').length;
      var outarr = new Array();
      if (lineCountCache != lineCount) {
        for (var x = 0; x < lineCount; x++) {
          outarr[x] = (x + 1) + ' ';
        }
        lineCounter.value = outarr.join('\n');
      }
      lineCountCache = lineCount;
    });
  }

  function line_counter(articleEditor, lineCounter) {
    var lineCountCache = 0;
    var lineCount = articleEditor.value.split('\n').length;
    var outarr = new Array();
    if (lineCountCache != lineCount) {
      for (var x = 0; x < lineCount; x++) {
        outarr[x] = (x + 1) + ' ';
      }
      lineCounter.value = outarr.join('\n');
    }
    lineCountCache = lineCount;
  }

  initEditOrderedList = function(page, add) {
    var addItem;
    var articlesPage = page == 'articles'
    $('.sortable').sortable();
    // Add article to popularity rankings
    $(add).click(function() {
      let exists = $(`#${addItem.id}`).length > 0
      if(addItem != undefined && articlesPage) {
        $('.sortable').append('<tr class="ui-sortable-handle">' +
            '<input type="hidden" name="article_ids[]" id="article_id" value="' + addItem.id + '">' +
            '<td class="hover-grab"></td>' +
            '<td class="hover-grab">' + addItem.name +
            '</td>' +
            '<td class="hover-grab">' + addItem.status +
            '</td>' +
            '<td>' +
            '<a target="_blank" href="https://www.fastweb.com/' + addItem.path + '">View</a>' +
            ' | ' +
            '<a class="remove" href="javascript:void(0);" onclick="$(this).closest(\'tr\').remove();">Remove</a>' +
            ' | ' +
            '<a href="/admin/articles/' + addItem.slug + '/edit">Edit</a>' +
            '</td>' +
          '</tr>'
        );
      } else if (addItem != undefined && !articlesPage && !exists) {
        // if were in article awards list, and item is added to table, add the award details form but hidden.
        addAwardDetailsForm(addItem.id, addItem.name)
        $('.sortable').append(`<tr class="ui-sortable-handle" id='${addItem.id}'> ` +
            '<input type="hidden" name="award_ids[]" id="award_id" value="' + addItem.id + '">' +
            '<td class="hover-grab"></td>' +
            '<td class="hover-grab">' + addItem.id +
            '</td>' +
            '<td class="hover-grab">' + addItem.name +
            '</td>' +
            '<td>' +
            `<a class="remove ${addItem.id} ${addItem.name}" onclick="removeRow(this)">Remove</a>` +
            ' | ' +
            `<a class="edit-award ${addItem.id} ${addItem.name}" onclick="showDetailsForm(this)">Edit Award Details</a>` +
          '</tr>'
        );
      }
      addItem = undefined;
      $('#search').val('');
    });

    // Remove article from popularity rankings
    $('.remove').click(function() {
      $(this).closest('tr').remove();
    });

    // Article search autocomplete
    $('#search').autocomplete({
      source: function(request, response) {
        url = window.location.origin + `/admin/${page}/search`;
        text = $('#search').val();
        channel_id = $('#channel_id').val() || '';
        $.ajax({
          url: url,
          dataType: "json",
          data: {q: text, channel_id: channel_id},
          method: 'GET',
          cache: false
        })
        .done(function(data, textStatus, jqXHR) {
          var results = $.map(data, function( item ) {
              var options = articlesPage ? { label: item.name, status: item.status, value: item.id, slug: item.slug, path: item.path } : {value: item.id, label: `#${item.id}-${item.name}`, name: item.name}
              return options
            });

          response(results);
        })
        .fail(function(jqHXR, textStatus, errorThrown) {
          console.log("Failed to retrieve autocomplete results - " + errorThrown);
        });
      },
      classes: {
        "ui-autocomplete": "white-bg",
      },
      minLength: articlesPage ? 2 : 1,
      delay: 0,
      select: function(event, ui) {
        options = articlesPage ? {id: ui.item.value, name: ui.item.label, status: ui.item.status, slug: ui.item.slug, path: ui.item.path} : {id: ui.item.value, name: ui.item.name}
        addItem = options
        event.preventDefault();
      },
      focus: function(event, ui) {
        event.preventDefault();
        options = articlesPage ? {id: ui.item.value, name: ui.item.label, status: ui.item.status, slug: ui.item.slug, path: ui.item.path} : {id: ui.item.value, name: ui.item.name}
        addItem = options
        $('#search').val(ui.item.label);
      }
    });
  }

  removeRow = function(award, options = {}) {
    // used to remove row from artilce awards list -- if user is updating list or had added new items
    let id, awardDetail
    if (Object.keys(options).length <= 0) {
      $(award).closest('tr').remove()
      id = $(award).attr('class').split(' ')[1]
    } else {
      $(`#${award}`).closest('tr').remove()
      id = award 
    }
    awardDetail = $(`.award-${id}`)
    if (awardDetail.length > 0) {
      awardDetail.remove()
    }
  }

  addAwardDetailsForm = function(id, name, options = {}) {
    // add award details form to DOM
    console.log(options)
    const form = awardDetailsForm(id, name, options)
    $("#edit-award-details").append(form);
  }

  showDetailsForm = function(award, options = {}) {
    let id;
    if (Object.keys(options).length > 0) {
       id = options.id
    } else {
      id = $(award).attr('class').split(' ')[1]
    }
    // if the edit award details link is clicked, show the form
    let awardDetail = $(`.award-${id}`)
    awardDetail.removeClass('hide')
  }

  awardDetailsForm = function (id, name, options) {
    // creates the award details form
    if ($(`.award-${id}`).length == 0) {
      award = Object.keys(options).length > 0
      return `<div class='card award-${id} ${options.show == undefined ? 'hide' : ''}'>` +
      '<div class="card-content">' +
        `<h3>${name} Details</h3>` +
        '<br/>' +
        `<input type='hidden' name='award_deadlines[${id}]' value=false />` +
        `<input type='checkbox' name='award_deadlines[${id}]' ${options.award_deadline == true || options.award_deadline == undefined ? 'checked' : ''} value=1 />` +
        ` Award Deadline ` +
        '<br/>' +
        `<input type='hidden' name='award_amounts[${id}]' value=false />` +
        `<input type='checkbox' name='award_amounts[${id}]' ${options.award_amount == true || options.award_amount == undefined ? 'checked' : ''} value=1 />` +
        ` Award Amount ` +
        '<br/>' +
        `<input type='hidden' name='apply_years[${id}]' value=false />` +
        `<input type='checkbox' name='apply_years[${id}]' ${options.apply_year == true || options.apply_year == undefined ? 'checked' : ''} value=1 /> ` +
        ` Apply Year ` +
        '<br/>' +
        ' Description' +
        `<textarea rows='3' name='descriptions[${id}]'>${award ? options.description : ''}</textarea>` +
        "<br/>" +
        `<a class='button' onclick=$('.award-${id}').addClass('hide')>Hide</a>` +
      "</div>" +
    "</div>"
    } else {
      $(`.award-${id}`).removeClass('hide')
    }
  }

  fetchSlugValFromArticleTitle = function(slug) {
    const slugField = $('#article-slug')
    // if the slug is empty - this means the artile/article title hasn't been created yet, allowing us to use the auto-generated slug functionality
    if (slug) {
      $('#article-title').blur(function(){
        var articleTitle = $(this).val();
        articleTitle = articleTitle.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
        slugField.val(articleTitle);
      })
    } else {
      // else the article already exists/user is editing it, we should disabled the slug field
      slugField.prop('disabled', true)
    }
  }

  setCharacterLimit = function(text, charCount) {
    $(text).on('keyup', function() {
      const length = $(this).val().length;
      $(charCount).html(length);
    });
  }

  return {
    init: init,
    initEditOrderedList: initEditOrderedList,
    fetchSlugValFromArticleTitle: fetchSlugValFromArticleTitle,
    setCharacterLimit: setCharacterLimit,
    validateArticleBodyForPlacements: validateArticleBodyForPlacements
  }

})(jQuery);
